import { Globals as OldGlobals } from "../../global/Globals";
import { useLanguage } from '../../context/Languagecontext';
import FallBackLabel from '../../global/Globals_Eng.json';
import React from "react";
import "./ProgressLoader.css";

const ProgressLoader = (props) => {
  const { Globals } = useLanguage();
  return (
    <div className={`mch-progress-loader ${props.component ? 'progress-loader_middle' :""}`}>
      <img width={props.width} height={props.height} src={Globals.LOADERS.SPINNING_LOADER} className="loader_img" />
      <p className="progress-loader-text">{Globals.PROGRESS_LOADER_TEXT}</p>
    </div>
  )
};

export default ProgressLoader
